const queryAuthKeys = ['client', 'join_group', 'cobranding', 'signup_network', 'redirect', 'utm_source', 'utm_campaign'];

export async function setAuthToken(token: string|null, redirect?: string|boolean) {
  const config = useRuntimeConfig()

  const authToken = useCookie(
    'auth_token',
    {
      secure: true,
      domain: config.public.domain,
      maxAge: 60*60*24*14
    }
  )

  authToken.value = token
  await refreshCookie('auth_token')
  const user = useState('profile')
  if (token) {
    if (!user.value) {
      user.value = (await $api(`https://www.${config.public.domain}/api/user/me`, {
        async onResponseError({ response }) {
          if (response.status === 401) {
            await setAuthToken(null)
          }
        }
      })).user
    }
    return redirectToAuthUserPage()
  } else {
    user.value = null
  }
  if (redirect !== false) {
    return navigateTo(redirect ? redirect : '/login', {external: true})
  }
}

export async function redirectToAuthUserPage()
{
  const route = useRoute()
  const config = useRuntimeConfig()
  const user = useState('profile').value
  const savedQueryParams = useCookie('auth_query_params')
  const currentQueryParams = queryAuthKeys.reduce((acc, key) => {
    if (route.query[key]) {
      acc[key] = route.query[key];
    }
    return acc;
  }, {})
  const query =  {...(savedQueryParams.value || {}), ...currentQueryParams}
  savedQueryParams.value = null
  if (user.id) {
    const redirect = route.query.redirect || query.redirect || null
    if (redirect && (redirect.startsWith('/') || redirect.startsWith(`https://www.${config.public.domain}`))) {
      return navigateTo(redirect, {redirectCode: 303, external: !redirect.startsWith('/')})
    }
    if (user.account_type === 'admin') {
      return navigateTo(`/admin`, {redirectCode: 303})
    }
    if (user.groups.length && !user.groups[0].parent) {
      return navigateTo(`/group/${user.groups[0].id}`, {redirectCode: 303})
    }
    if (user.platforms.length) {
      return navigateTo(`/platform/${user.platforms[0].id}`, {redirectCode: 303})
    }
    if (user.account_type === 'organization' && !user.organizations.length) {
        return navigateTo({path: '/organization/new', query}, {redirectCode: 303})
    }
    return navigateTo({path: `https://www.${config.public.domain}/dashboard`, query}, {redirectCode: 303, external: true})
  }
}

export function saveQueryParams() {
  const queryParams = useCookie('auth_query_params', {maxAge: 60 * 60})
  const utmSource = useCookie('espaceasso_utm_source', {maxAge: 60 * 60 * 24, domain: useDomain()})
  const utmCampaign = useCookie('espaceasso_utm_campaign', {maxAge: 60 * 60 * 24, domain: useDomain()})

  queryParams.value = {}

  queryAuthKeys.forEach(key => {
    if (key === 'utm_source' && utmSource.value) {
      queryParams.value[key] = utmSource.value;
    } else if (key === 'utm_campaign' && utmCampaign.value) {
      queryParams.value[key] = utmCampaign.value;
    } else if (useRoute().query[key]) {
      queryParams.value[key] = useRoute().query[key];
    }
  });
}